import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseUrl } from "../Univ";
import { DataGrid, GridToolbar, GridPagination } from "@mui/x-data-grid";
import { Link } from "react-router-dom";

function Orders() {

  const [orders, setOrders] = useState([]);

  // -------------------------
  // FETCH ORDERS
  // -------------------------
  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {

    const res = await axios.get(
      baseUrl + "admin-orders/",
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
      }
    );

    // Flatten orders for grid
    const rows = res.data.map((order) => ({
      id: order.id,
      order_id: order.order_id,
      date: order.created_at,
      status: order.status,
      payment: order.payment_method,
      total: order.total_amount,
      items: order.items
    }));

    setOrders(rows);
  };

  // -------------------------
  // COLUMNS
  // -------------------------
  const columns = [

    { field: "id", headerName: "Order ID", width: 100 },

    { field: "date", headerName: "Date", width: 200 },

    { field: "status", headerName: "Status", width: 130 },

    { field: "payment", headerName: "Payment", width: 150 },

    { field: "total", headerName: "Amount", width: 130 },

    {
      field: "invoice",
      headerName: "Invoice",
      width: 150,
      renderCell: (params) => (

        params.row.status === "PAID" ||

        params.row.status === "COD" ?

        <Link
          to={`/invoice/${params.row.id}`}
          style={{
            color: "blue",
            textDecoration: "underline"
          }}
        >
          View Invoice
        </Link>

        :

        <span style={{color:"gray"}}>Not Available</span>

      )
    },

{
  field: "track",
  headerName: "Track Delivery",
  width: 250,

  renderCell: (params) => {
    const items = params.row?.items || [];

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
        {items.map((item, index) => (
          <Link key={item.id} to={`/track-delivery/${item.id}`}>
            <button
              style={{
                padding: "6px 12px",
                background: "#198754",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",

              }}
            >
              Track Item {index + 1}
            </button>
          </Link>
        ))}
      </div>
    );
  }
}

  ];

  // -------------------------
  // UI
  // -------------------------
  return (

    <div className="container mt-4">

      <h3>My Orders</h3>

      <DataGrid
        sx={{
          boxShadow: 4,
          border: 4,
          borderColor: "primary.light",
          "& .MuiDataGrid-cell:hover": {
            color: "primary.main",
          },
        }}

        rows={orders}
        columns={columns}

        pageSizeOptions={[10,25,50,100]}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 10, page: 0 }
          }
        }}

        slots={{
          toolbar: GridToolbar,
          Pagination: GridPagination,
        }}
        getRowHeight={() => "auto"}   // 🔥 THIS LINE
        autoHeight
      />

    </div>

  );

}

export default Orders;
